export default [
    //日常练习-课件学习管理-学生观看情况
    {
        path: "rclx/kjxxgl/watched-detail",
        name: "KjxxLearningQkList",
        component: () =>  import('./kjxxgl/KjxxLearningQkList.vue')
    },
	//日常练习-课件学习管理-学生观看情况-详情
    {
        path: "rclx/kjxxgl/student-watched-detail",
        name: "KjxxLearningQkDetail",
        component: () =>  import('./kjxxgl/KjxxLearningQkDetail.vue')
    },
    //日常练习-课件学习管理-学习进度统计
    {
        path: "rclx/kjxxgl/study-plan-tongji",
        name: "KjxxLearningProgressList",
        component: () =>  import('./kjxxgl/KjxxLearningProgressList.vue')
    },
    //日常练习-课件学习管理-commlist
    {
        path: "rclx/kjxxgl/bkkj-tongji",
        name: "KjxxBkkjTongjiList",
        component: () =>  import('./kjxxgl/KjxxBkkjTongjiList.vue')
    },

    //日常练习-学习成绩管理-
    {
        path: "rclx/xxcjgl/student-score-list",
        name: "StdLearningScoreList",
        component: () =>  import('./xxcjgl/StdLearningScoreList.vue')
    },
    //日常练习-培训成绩管理-培训成绩查询
    {
        path: "rclx/pxcjgl/training-score-query",
        name: "TrainingScoreQueryList",
        component: () =>  import('./pxcjgl/TrainingScoreQueryList.vue')
    },
    //日常练习-培训成绩管理-培训成绩统计
    {
        path: "rclx/pxcjgl/training-score-list",
        name: "TrainingScoreTongJiList",
        component: () =>  import('./pxcjgl/TrainingScoreTongJiList.vue')
    },

    //培训计划-培训批次设置
    {
        path: "rclx/pxjh/training-batch-list",
        name: "TrainingBatchConfigList",
        component: () =>  import('./pxjh/TrainingBatchConfigList.vue')
    },
	{
        path: "rclx/pxjh/training-batch-add",
        name: "TrainingBatchConfigAdd",
        component: () =>  import('./pxjh/TrainingBatchConfigAdd.vue')
    },
	{
        path: "rclx/pxjh/training-batch-edit",
        name: "TrainingBatchConfigEdit",
        component: () =>  import('./pxjh/TrainingBatchConfigEdit.vue')
    },
    //培训计划-培训课程设置
    {
        path: "rclx/pxjh/training-course-list",
        name: "TrainingCourseConfigList",
        component: () =>  import('./pxjh/TrainingCourseConfigList.vue')
    },
    //培训计划-培训课程设置
    {
        path: "rclx/pxjh/training-course-sz",
        name: "TrainingCourseConfigShezhi",
        component: () =>  import('./pxjh/TrainingCourseConfigShezhi.vue')
    },


    //培训计划-培训成绩合成标准
    {
        path: "rclx/pxjh/training-score-comb-percent-list",
        name: "TrainingScoreCombPercentList",
        component: () =>  import('./pxjh/TrainingScoreCombPercentList.vue')
    },
    //直播管理-直播列表
    {
        path: "rclx/zbgl/zhibo-list",
        name: "ZhiboList",
        component: () =>  import('./zbgl/ZhiboList.vue')
    },
    //直播管理-新增直播课堂
    {
        path: "rclx/zbgl/zhibo-add",
        name: "ZhiboAdd",
        component: () =>  import('./zbgl/ZhiboAdd.vue')
    },
    //直播管理-编辑直播课堂
    {
        path: "rclx/zbgl/zhibo-edit",
        name: "ZhiboEdit",
        component: () =>  import('./zbgl/ZhiboEdit.vue')
    },
    //直播管理-直播列表-直播现场
    {
        path: "rclx/zbgl/zhibo-xc",
        name: "ZhiboXianchang",
        component: () =>  import('./zbgl/ZhiboXianchang.vue')
    },
	//直播管理-直播列表-直播现场
    {
        path: "rclx/zbgl/zhibo-replay",
        name: "ZhiboPlayBack",
        component: () =>  import('./zbgl/ZhiboPlayBack.vue')
    },
    //直播管理-学生观看情况
    {
        path: "rclx/zbgl/zhibo-learning-qk-list",
        name: "ZhiboLearningQkList",
        component: () =>  import('./zbgl/ZhiboLearningQkList.vue')
    },
    //直播管理-学习进度统计
    {
        path: "rclx/zbgl/zhibo-learning-progress-list",
        name: "ZhiboLearningProgressList",
        component: () =>  import('./zbgl/ZhiboLearningProgressList.vue')
    },
    //试卷管理-平时作业
    {
        path: "rclx/sjgl/homework-paper-list",
        name: "HomeworkPaperList",
        component: () =>  import('./sjgl/HomeworkPaperList.vue')
    },
    //试卷管理-平时作业配置
    {
        path: "rclx/sjgl/homework-paper-config",
        name: "HomeworkPaperPeizhi",
        component: () =>  import('./sjgl/HomeworkPaperPeizhi.vue')
    },
    //试卷管理-平时作业-创建试卷
    {
        path: "rclx/sjgl/homework-paper-add",
        name: "HomeworkPaperAdd",
        component: () =>  import('./sjgl/HomeworkPaperAdd.vue')
    },
    //试卷管理-平时作业修改
    {
        path: "rclx/sjgl/homework-paper-edit",
        name: "HomeworkPaperEdit",
        component: () =>  import('./sjgl/HomeworkPaperEdit.vue')
    },
    //试卷管理-平时作业详情
    {
        path: "rclx/sjgl/homework-paper-view",
        name: "HomeworkPaperView",
        component: () =>  import('./sjgl/HomeworkPaperView.vue')
    },
    //试卷管理-综合测验
    {
        path: "rclx/sjgl/exam-paper-list",
        name: "ExamPaperList",
        component: () =>  import('./sjgl/ExamPaperList.vue')
    },
    //试卷管理-综合测验配置
    {
        path: "rclx/sjgl/exam-paper-peizhi",
        name: "ExamPaperPeizhi",
        component: () =>  import('./sjgl/ExamPaperPeizhi.vue')
    },
    //试卷管理-综合测验修改ExamPaperView
    {
        path: "rclx/sjgl/exam-paper-edit",
        name: "ExamPaperEdit",
        component: () =>  import('./sjgl/ExamPaperEdit.vue')
    },
    //试卷管理-综合测验创建试卷
    {
        path: "rclx/sjgl/exam-paper-add",
        name: "ExamPaperAdd",
        component: () =>  import('./sjgl/ExamPaperAdd.vue')
    },
    //试卷管理-综合测验 详情按钮-页面
    {
        path: "rclx/sjgl/exam-paper-view",
        name: "ExamPaperView",
        component: () =>  import('./sjgl/ExamPaperView.vue')
    },
    //日常练习 平时作业记录 已做记录
    {
        path: "rclx/pszyjl/homework-done-list",
        name: "HomeworkYzRecordList",
        component: () =>  import('./pszyjl/HomeworkYzRecordList.vue')
    },
    //日常练习 平时作业记录 未做记录
    {
        path: "rclx/pszyjl/homework-nodone-list",
        name: "HomeworkWzRecordList",
        component: () =>  import('./pszyjl/HomeworkWzRecordList.vue')
    },
    //日常练习 平时作业记录 作业监控
    {
        path: "rclx/pszyjl/homework-monitor",
        name: "HomeworkMonitor",
        component: () =>  import('./pszyjl/HomeworkMonitor.vue')
    },
    //日常练习 平时作业记录 批阅试卷
    {
        path: "rclx/pszyjl/homework-done-pysj",
        name: "HomeworkYzPysj",
        component: () =>  import('./pszyjl/HomeworkYzPysj.vue')
    },
    //日常练习 综合测验记录 已做记录ExamYzPysj
    {
        path: "rclx/zhcyjl/exam-done-list",
        name: "ExamYzRecordList",
        component: () =>  import('./zhcyjl/ExamYzRecordList.vue')
    },
    //日常练习 综合测验记录 未做记录
    {
        path: "rclx/zhcyjl/exam-nodone-list",
        name: "ExamWzRecordList",
        component: () =>  import('./zhcyjl/ExamWzRecordList.vue')
    },
    //日常练习 综合测验记录 已做记录
    {
        path: "rclx/zhcyjl/exam-done-pysj",
        name: "ExamYzPysj",
        component: () =>  import('./zhcyjl/ExamYzPysj.vue')
    },
    //日常练习 综合测验记录 监控
    {
        path: "rclx/zhcyjl/exam-monitor",
        name: "ExamMonitor",
        component: () =>  import('./zhcyjl/ExamMonitor.vue')
    },
    //日常练习 课件监控
    {
        path: "rclx/kjxxgl/course-learn-monitor-list",
        name: "CourseLearnMonitorList",
        component: () =>  import('./kjxxgl/CourseLearnMonitorList.vue')
    },
    //日常练习-直播管理-直播详情管理
    {
        path: "rclx/zbgl/zhi-bo-detail-list",
        name: "ZhiboDetailList",
        component: () =>  import('./zbgl/ZhiboDetailList.vue')
    },
	// 日常练习-试卷管理-平时作业自动组卷
	{
		path: "rclx/sjgl/homework-paper-zdzj",
		name: "HomeworkPaperZdzj",
		component: () =>  import('./sjgl/HomeworkPaperZdzj.vue')
	},
	//日常练习-试卷管理-综合测验自动组卷
	{
		path: "rclx/sjgl/exam-paper-zdzj",
		name: "ExamPaperZdzj",
		component: () =>  import('./sjgl/ExamPaperZdzj.vue')
	}
];






